import React, { useEffect, useState } from "react";
import { descending } from "../assets";
import { useNavigate } from "react-router-dom";
import { changeDateFormat, getUserTransactions } from "../constants";

const SettingPackage = ({ packageData, token }) => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);

  useEffect(() => {
    getUserTransactions(token, setData);
  }, []);

  return (
    <div className="flex flex-col w-full gap-5">
      <div className="font-bold">Package Plan</div>
      <div className="flex flex-col gap-3">
        <div className="flex flex-row items-center w-full">
          <div className="flex flex-col w-1/3">Package Type</div>
          <div>: {packageData.name}</div>
        </div>
        <div className="flex flex-row items-center w-full">
          <div className="flex flex-col w-1/3">Expiration Date</div>
          <div>: {changeDateFormat(packageData.period_end_at)}</div>
        </div>
        {packageData.name.toLowerCase().includes("free") && (
          <div
            className="flex flex-col px-5 py-2 bg-primary text-white w-fit rounded-lg hover:bg-secondary cursor-pointer"
            onClick={() => navigate("/plan/upgrade")}
          >
            Upgrade package
          </div>
        )}
      </div>
      <div className="font-bold">Transaction History</div>
      <div className="w-full overflow-x-auto rounded-3xl border-2 border-primary">
        <table className="w-full min-w-[800px] border-collapse">
          <thead>
            <tr className="text-black font-bold">
              {/* We use px-4 and py-4 to match your original padding */}
              <th className="px-4 py-4 text-left">
                <div className="flex items-center gap-2 cursor-pointer">
                  Date <img src={descending} alt="" />
                </div>
              </th>
              <th className="px-4 py-4 text-left">
                <div className="flex items-center gap-2 cursor-pointer">
                  Transaction No <img src={descending} alt="" />
                </div>
              </th>
              <th className="px-4 py-4 text-left">
                <div className="flex items-center gap-2 cursor-pointer">
                  Package Plan <img src={descending} alt="" />
                </div>
              </th>
              <th className="px-4 py-4 text-left">
                <div className="flex items-center gap-2 cursor-pointer">
                  Price <img src={descending} alt="" />
                </div>
              </th>
              <th className="px-4 py-4 text-left">
                <div className="flex items-center gap-2 cursor-pointer">
                  Status <img src={descending} alt="" />
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            {data.map((val, ind) => (
              <tr key={ind} className="border-t-2 border-primary">
                <td className="px-4 py-4 text-sm whitespace-pre-line">
                  {val.date}
                </td>
                <td className="px-4 py-4 text-sm">{val.transaction_no}</td>
                <td className="px-4 py-4 text-sm">{val.package_plan}</td>
                <td className="px-4 py-4 text-sm font-semibold">{val.price}</td>
                <td className="px-4 py-4 text-sm uppercase font-bold">
                  {val.status}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SettingPackage;
